export default {"src":"/_next/static/media/petrolboys-colored.ef9a1fe5.svg","height":161,"width":696,"blurWidth":0,"blurHeight":0};